"use client";

import { useEffect } from "react";

export function DisableConsole() {
  useEffect(() => {
    if (process.env.NODE_ENV === "production" && typeof window !== "undefined") {
      const noop = () => undefined;
      // console.log = noop;
      // console.info = noop;
      // console.debug = noop;
      // console.warn = noop;
      // on garde error pour diagnostiquer
    }
  }, []);
  return null;
}
